import { Module } from '@nestjs/common';
import { GSuiteMailerService } from './g-sute-mailer.service';
import { MailerController } from './mailer.controller';

@Module({
  controllers: [MailerController],
  providers: [GSuiteMailerService],
  exports:[GSuiteMailerService]
})
export class MailerModule {}
